import { FIND_OR_CREATE_SHOPKEEPER } from "../constants/endpoints";
import axiosClient from "./axios";

class FindOrCreateShopkeeperService {
  static async findOrCreate(email: string) {
    return await axiosClient.post(FIND_OR_CREATE_SHOPKEEPER, { email });
  }
}

export default FindOrCreateShopkeeperService;
